<template>
  <div>
    <div class="vx-row items-center" v-if="!is_sample_order_invoices">
      <div class="vx-col w-full sm:w-1/2 md:w-1/4" v-for="currency in invoice_total_currencies" :key="currency">
        <shortcut-card hideChart :iconText="currencySymbol(currency)" icon-right
          :statistic="sales_order_invoice_totals[currency] && sales_order_invoice_totals[currency].value != null ? sales_order_invoice_totals[currency].value : '-'"
          statisticSuffix="Incl VAT"
          :statisticTitle="`Invoice Total ${currency}`" color="success" class="mb-base" />
      </div>
      <div class="vx-col w-auto mb-base">
        <vx-card class="overflow-hidden h-full">
          <div slot="no-body" class="p-6 h-full flex items-center">
            <span class="cursor-pointer flex items-center" @click="openInvoiceTotalDatePicker">
              <feather-icon icon="CalendarIcon" svgClasses="h-8 w-8 text-primary" />
              <span class="ml-2 font-bold">{{ invoice_total_date }}</span>
            </span>
            <flat-pickr
              ref="invoiceTotalDatePicker"
              v-model="invoice_total_date"
              :config="{ dateFormat: 'd/m/Y' }"
              style="position: absolute; width: 0; height: 0; padding: 0; border: 0; opacity: 0; pointer-events: none;"
            />
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="mb-3">
          <div class="flex">
            <h5 class="text-warning">Show sample order invoice list</h5>
            <vs-checkbox class="ml-4 text-warning" color="warning" :disabled="!is_data_loaded" v-model="is_sample_order_invoices" @input="onChangeInvoiceType"></vs-checkbox>
          </div>
        </vx-card>
        <vx-card v-can="'view-invoice'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
                 :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>

              <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['from_date']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['from_date']"
                          placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['to_date']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['to_date']"
                          placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select multiple :options="['In Draft', 'Sent', 'Paid', 'Overdue', 'Cancelled']" v-model="filters['status']"/>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}">CLEAR
              </vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card :title="is_sample_order_invoices ? 'CUSTOMER INVOICES (SAMPLE ORDER)' : 'CUSTOMER INVOICES (SALES ORDER)'" v-can="'view-invoice'">
          <template slot="actions">
            <div class="flex" v-if="!is_sample_order_invoices">
              <excel-download :name="'so-invoice-sheet'" :filters="filters" />
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              id="invoice-list"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="invoice_list"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th>INVOICE NUMBER</vs-th>
                <vs-th>INVOICE DATE</vs-th>
                <vs-th>INVOICE DUE DATE</vs-th>
                <vs-th>CUSTOMER NAME & ACCOUNT NUMBER</vs-th>
                <vs-th>TOTAL INV AMOUNT Incl VAT</vs-th>
                <vs-th>PRODUCT ORDER CODE</vs-th>
                <vs-th width="5%">ACCOUNT TYPE</vs-th>
                <vs-th >SAGE</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].number">
                    {{ data[indextr].number }}
                  </vs-td>

                  <vs-td :data="data[indextr].date">
                    {{ data[indextr].date }}
                  </vs-td>

                  <vs-td :data="data[indextr].due_date">
                    {{ data[indextr].due_date || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].invoice_to_company_name">
                    <HyperLink v-if="!!data[indextr].customer_id" :id="data[indextr].customer_id" type="customer"><span>
                      {{ data[indextr].invoice_to_company_name }} <br>
                      {{ data[indextr].customer_account_number }}
                    </span></HyperLink>
                    <span v-if="is_sample_order_invoices && !!data[indextr].customer_lead" @click.stop="onClickViewCustomerLead(data[indextr].customer_lead)" class="cursor-pointer text-success">
                      {{ data[indextr].customer_lead.company_name }}
                      {{ data[indextr].customer_lead.code }}
                    </span>
                  </vs-td>

                  <vs-td>
                    {{ calculateTotalInvoiceAmount(data[indextr].items, data[indextr].add_cost, data[indextr].fx_value) }}
                    {{ data[indextr].invoice_currency || 'GBP' }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    <vx-tooltip class="ml-2" text="View Order" position="left">
                      <span class="text-primary cursor-pointer" @click.stop="onClickViewProductOrder(data[indextr].product_order_id || data[indextr].sample_order_id)">
                        {{ data[indextr].product_order_code || data[indextr].sample_order_code }}
                      </span>
                    </vx-tooltip>
                  </vs-td>

                  <vs-td>
                    <vx-tooltip class="ml-2" :text="`${data[indextr].customer_account_type} account`" position="top">
                      <span class="font-bold text-md" :class="data[indextr].customer_account_type === 'proforma' ? 'text-danger' : 'text-success'">
                         {{ data[indextr].customer_account_type === 'proforma' ? 'P' : 'C' }}
                      </span>
                    </vx-tooltip>
                  </vs-td>

                  <vs-td>
                    <span
                      class="text-danger cursor-pointer"
                      :id="`invoice_row_${indextr}`"
                    >
                      <vx-tooltip v-if="!data[indextr].sage_invoice_urn && canShowSageInvoiceAction(data[indextr])" class="mr-2" :text="data[indextr].sage_customer_id
                            ? 'Sync invoice with sage'
                            : 'Please sync customer with sage first'
                        " position="left">
                        <vs-button :disabled="!data[indextr].sage_customer_id" @click.stop="is_sample_order_invoices ? onClickSageSyncSampleInvoice(data[indextr], indextr) : onClickSageSyncInvoice(data[indextr], indextr)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>

                      <vx-tooltip v-else-if="data[indextr].sage_invoice_urn && canShowSageInvoiceAction(data[indextr])" class="mr-2" :text="`Sage Ref: ${data[indextr].sage_invoice_urn}`" position="left">
                        <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-check"/>
                      </vx-tooltip>

                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip transparent :color="invoiceStatusColorFactory(data[indextr].status.name)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View invoice details" position="top">
                        <vs-button
                          size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
<!--                      <vx-tooltip class="ml-2" text="View invoice details" position="left">-->
<!--                        <vs-button @click.stop="onClickViewInvoice(data[indextr].id)"-->
<!--                                   size="small" color="danger" type="border" icon-pack="feather"-->
<!--                                   icon="icon-printer"></vs-button>-->
                      <vx-tooltip
                        v-if="is_sample_order_invoices && ['In-Draft', 'In Draft'].includes(data[indextr].status.name)"
                        class="ml-2"
                        text="Update invoice" position="top">
                        <vs-button @click.stop="onClickUpdateSampleInvoice(data[indextr])" size="small"
                                   color="warning" type="border" icon-pack="feather"
                                   icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['Sent', 'Overdue'].includes(data[indextr].status.name) || ( data[indextr].customer_account_type === 'proforma' && data[indextr].status.name !== 'Paid')"
                                  class="ml-2" text="Status change to inv paid" position="top">
                        <vs-button @click.stop="onClickConfirmStatusChange(data[indextr].id, 'paid', data[indextr].number)"
                                   size="small" color="success" type="filled" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['In Draft', 'Overdue', 'Sent', 'In-Draft'].includes(data[indextr].status.name)"
                                  class="ml-2" text="Status change to inv cancel" position="top">
                        <vs-button @click.stop="onClickConfirmStatusChange(data[indextr].id, 'cancel', data[indextr].number)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Invoice Print/Download/Send" position="top">
                        <vs-button @click.stop="onClickViewInvoice(data[indextr].id, data[indextr].product_order_code || data[indextr].sample_order_code, data[indextr].status.name,
                        data[indextr].invoice_secret_code, data[indextr].last_email_sent_at, data[indextr].customer_id, data[indextr].customer_lead)"
                                   size="small" color="danger" type="border" icon-pack="feather"
                                   icon="icon-printer"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="View Invoice Logs" position="top">
                        <vs-button @click.stop="onClickViewInvoiceLogs(data[indextr].id, data[indextr].number)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-list"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Overdue" position="top" v-if="!is_sample_order_invoices">
                        <vs-button v-if="checkOverDue(data[indextr].due_date, data[indextr].status.name)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-bell"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-4/5">
                      <vs-table :data="tr.items">

                        <template slot="header">
                          <h5 class="mb-4">Invoice items</h5>
                        </template>

                        <template slot="thead">
                          <vs-th>ITS PRODUCT CODE</vs-th>
                          <vs-th>ITS PRODUCT NAME</vs-th>
                          <vs-th>NOMINAL CODE</vs-th>
                          <vs-th>SAGE DEPARTMENT</vs-th>
                          <vs-th>QUANTITY ({{ is_sample_order_invoices ? 'GR' : 'KG' }})</vs-th>
                          <vs-th>UNIT PRICE (KG/{{ tr.invoice_currency || 'GBP' }})</vs-th>
                          <vs-th>AMOUNT (Excl VAT) in {{ tr.invoice_currency || 'GBP' }}</vs-th>
                          <vs-th>AMOUNT (Incl VAT) in {{ tr.invoice_currency || 'GBP' }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_inv" v-for="(tr_inv, index_inv) in data">

                            <vs-td :data="tr_inv.formulation_code">
                              <HyperLink :id="tr_inv.formulation_id" type="formulation">{{ tr_inv.formulation_code }}</HyperLink>
                            </vs-td>

                            <vs-td :data="tr_inv.formulation_name">
                              {{ tr_inv.formulation_name }}
                            </vs-td>

                            <vs-td>
                              {{ tr_inv.sage_nominal_code ? tr_inv.sage_nominal_code.code : 'N/A' }}
                            </vs-td>

                            <vs-td>
                              {{ tr_inv.sage_department ? tr_inv.sage_department.name : 'N/A' }}
                            </vs-td>

                            <vs-td :data="tr_inv.quantity">
                              {{ tr_inv.quantity }}
                            </vs-td>

                            <vs-td :data="tr_inv.price">
                              {{ is_sample_order_invoices ? formatPrice(tr_inv.price, tr.fx_value || 1) : tr_inv.price }}
                            </vs-td>

                            <vs-td :data="tr_inv.amount_ex_vat">
                              {{ is_sample_order_invoices ? calculateItemAmountExVat(tr_inv, tr.fx_value || 1) : tr_inv.amount_ex_vat }}
                            </vs-td>

                            <vs-td :data="tr_inv.amount_in_vat">
                              {{ is_sample_order_invoices ? calculateItemAmountInVat(tr_inv, tr.fx_value || 1) : tr_inv.amount_in_vat }}
                            </vs-td>

                          </vs-tr>
                        </template>

                      </vs-table>

                      <vs-table class="mt-8" :data="tr.add_cost">

                        <template slot="header">
                          <h5 class="mb-4">Additional cost</h5>
                        </template>

                        <template slot="thead">
                          <vs-th>NAME</vs-th>
                          <vs-th>NOMINAL CODE</vs-th>
                          <vs-th>SAGE DEPARTMENT</vs-th>
                          <vs-th>AMOUNT (Excl VAT) in {{ tr.invoice_currency || 'GBP' }}</vs-th>
                          <vs-th>AMOUNT (Incl VAT) in {{ tr.invoice_currency || 'GBP' }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                            <vs-td :data="tr_cost.name">
                              {{ tr_cost.name }}
                            </vs-td>

                            <vs-td>
                              {{ tr_cost.sage_nominal_code ? tr_cost.sage_nominal_code.code : 'N/A' }}
                            </vs-td>

                            <vs-td>
                              {{ tr_cost.sage_department ? tr_cost.sage_department.name : 'N/A' }}
                            </vs-td>

                            <vs-td :data="tr_cost.amount_ex_vat">
                              {{ is_sample_order_invoices ? calculateCostAmountExVat(tr_cost, tr.fx_value || 1) : tr_cost.amount_ex_vat }}
                            </vs-td>

                            <vs-td :data="tr_cost.amount_in_vat">
                              {{ is_sample_order_invoices ? calculateCostAmountInVat(tr_cost, tr.fx_value || 1) : tr_cost.amount_in_vat }}
                            </vs-td>

                          </vs-tr>
                        </template>

                      </vs-table>
                      <div class="vx-row mt-8">
                        <div class="vx-col w-full">
                          <h5>Notes</h5>
                          {{ tr.note || 'N/A' }}
                        </div>
                      </div>
                      <div class="vx-row mt-8 mb-8 text-primary">
                        <div class="vx-col w-1/2 float-right font-bold">
                          Total invoice value ({{ tr.invoice_currency || 'GBP' }}) :
                          {{ calculateTotalInvoiceAmount(tr.items, tr.add_cost, tr.fx_value) }}
                        </div>
                      </div>

                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <sample-order-invoice-pdf-pop-up ref="sampleOrderInvoicePdfPopUp"/>
    <sample-order-invoice ref="sampleOrderInvoice" @refreshData="refreshData"/>
    <product-order-invoice-pdf-pop-up ref="productOrderInvoicePdfPopUp"/>
    <sales-order-invoice ref="salesOrderInvoice" @refreshData="refreshData"/>
    <view-sales-order-invoice-log-pop-up ref="viewSalesOrderInvoiceLogPopUp"/>
    <update-sample-order-invoice-pop-up ref="updateSampleOrderInvoicePopUp" @refreshData="refreshData"/>
  </div>
</template>

<script>
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import {defaultPagination, perPageList} from "@/constants/config";
import {mapActions, mapGetters} from "vuex";
import ProductOrderInvoicePdfPopUp
  from "@/components/popups/customer/product-orders/invoices/ProductOrderInvoicePdfPopUp";
import SalesOrderInvoice from '@/components/popups/pdf/SalesOrderInvoice.vue';
import SampleOrderInvoice from '@/components/popups/pdf/SampleOrderInvoice.vue';
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import vSelect from "vue-select";
import router from "@/router";

import {RepositoryFactory} from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')
const SageRepository = RepositoryFactory.get('sage')
const ReportingRepository = RepositoryFactory.get('reporting')
import SageHelper from '@/mixins/SageHelper'
import SampleOrderInvoicePdfPopUp from '@/components/popups/customer/sample-orders/invoices/SampleOrderInvoicePdfPopUp.vue'
const RegionsRepository = RepositoryFactory.get('regions');
import ViewSalesOrderInvoiceLogPopUp from '@/components/popups/customer/product-orders/invoices/ViewSalesOrderInvoiceLogPopUp.vue'
import UpdateSampleOrderInvoicePopUp from '@/components/popups/customer/sample-orders/invoices/UpdateSampleOrderInvoicePopUp.vue'
import ShortcutCard from '@/components/shortcut-cards/ShortcutCard.vue'
export default {
  name: 'InvoiceList',
  components: {
    ProductOrderInvoicePdfPopUp,
    flatPickr,
    'v-select': vSelect,
    SampleOrderInvoicePdfPopUp,
    SampleOrderInvoice,
    ViewSalesOrderInvoiceLogPopUp,
    SalesOrderInvoice,
    ShortcutCard,
    UpdateSampleOrderInvoicePopUp,
  },
  data() {
    return {
      filters: {},
      page: 1,
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      account_currency: 'GBP',
      is_sample_order_invoices: false,
      is_data_loaded: false,
      invoice_total_currencies: ['GBP', 'EUR', 'USD'],
      sales_order_invoice_totals: { GBP: {}, EUR: {}, USD: {} },
      invoice_total_date: moment().format('DD/MM/YYYY'),
    }
  },
  mounted() {
    this.setFilterId('customer_invoice_list_filters',['status','from_date','to_date','search'])
    this.fetchSalesOrderInvoiceTotal()
  },
  computed: {
    ...mapGetters({
      invoice_list: 'invoices',
      meta: 'invoice_meta',
    }),
  },
  mixins: [Filter, SuccessMessage, ErrorMessages, SageHelper],
  methods: {
    ...mapActions(['fetchAllInvoices', 'fetchSampleInvoices']),
    async fetchSalesOrderInvoiceTotal() {
      try {
        const results = await Promise.all(
          this.invoice_total_currencies.map(currency => ReportingRepository.getSalesOrderInvoiceTotal(this.invoice_total_date, currency))
        )
        results.forEach((res, idx) => {
          const currency = this.invoice_total_currencies[idx]
          this.$set(this.sales_order_invoice_totals, currency, res.data.data)
        })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    currencySymbol(currency) {
      return this.__currencySymbol(currency) || currency
    },
    canShowSageInvoiceAction(invoice) {
      if (invoice.sage_invoice_urn) {
        return true
      }
      if (!this.is_sample_order_invoices) {
        return true
      }
      return !invoice.customer_lead || invoice.customer_lead === ''
    },
    openInvoiceTotalDatePicker() {
      if (this.$refs.invoiceTotalDatePicker && this.$refs.invoiceTotalDatePicker.fp) {
        this.$refs.invoiceTotalDatePicker.fp.open()
      }
    },
    refreshData() {
      this.fetchInvoiceList()
    },
    async fetchInvoiceList() {
      await this.$vs.loading({
        container: '#invoice-list',
        scale: 0.45
      })
      try {
        this.is_data_loaded = false
        if(this.is_sample_order_invoices) {
          await this.fetchSampleInvoices({page: this.page, filterQuery: this.filterQuery, perPage: this.perPage})
        } else {
          await this.fetchAllInvoices({page: this.page, filterQuery: this.filterQuery, perPage: this.perPage})
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.is_data_loaded = true
        this.$vs.loading.close('#invoice-list > .con-vs-loading')
      }
    },
    formatPrice(value, fx_rate = 1) {
      if (this.$options.filters && this.$options.filters.format_price) {
        return this.$options.filters.format_price(value, fx_rate)
      }
      const rate = Number(fx_rate) || 1
      const amount = Number(value || 0)
      return (amount * rate).toFixed(2)
    },
    calculateItemAmountExVat(item, fx_rate = 1) {
      if (!item) return '0.00'
      const unitPrice = Number(this.formatPrice(item.price, fx_rate))
      const qtyInKg = Number(item.quantity || 0) / 1000
      return (qtyInKg * unitPrice).toFixed(2)
    },
    calculateItemAmountInVat(item, fx_rate = 1) {
      if (!item) return '0.00'
      const amountExVat = Number(this.calculateItemAmountExVat(item, fx_rate))
      const taxRate = Number(item.tax_percent || 0) / 100
      return (amountExVat * (1 + taxRate)).toFixed(2)
    },
    calculateCostAmountExVat(cost, fx_rate = 1) {
      if (!cost) return '0.00'
      return Number(this.formatPrice(cost.amount_ex_vat || cost.amount, fx_rate)).toFixed(2)
    },
    calculateCostAmountInVat(cost, fx_rate = 1) {
      if (!cost) return '0.00'
      const ex = Number(this.calculateCostAmountExVat(cost, fx_rate))
      const vatPercent = Number(cost.vat_percent || 0) / 100
      return (ex * (1 + vatPercent)).toFixed(2)
    },
    calculateTotalInvoiceAmount(inv_items = [], add_cost = [], fx_rate = 1) {
      if (this.is_sample_order_invoices) {
        const rate = fx_rate || 1
        const total_inv = (inv_items || []).reduce((a, b) => a + Number(this.calculateItemAmountInVat(b, rate)), 0)
        const total_add_cost = (add_cost || []).reduce((a, b) => a + Number(this.calculateCostAmountInVat(b, rate)), 0)
        return Number(total_inv + total_add_cost).toFixed(2)
      }
      const total_inv = Number((inv_items || []).reduce((a, b) => a + Number(b.amount_in_vat), 0))
      const total_add_cost = Number((add_cost || []).reduce((a, b) => a + Number(b.amount_in_vat), 0))
      return Number(total_inv + total_add_cost).toFixed(2)
    },
    filterQueryUpdate() {
      this.page = 1
      this.fetchInvoiceList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchInvoiceList()
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    invoiceStatusColorFactory(status) {
      switch (status) {
        case 'In Draft':
        case 'In-Draft':
          return 'warning'
        case 'Paid':
          return 'primary'
        case 'Refunded':
          return 'warning'
        case 'Cancelled':
          return 'danger'
        case 'Sent':
          return 'primary'
      }
    },
    onClickViewInvoice(id, product_order_code, status, secret_code, last_email_sent_at, customer_id, customer_lead = null) {
      if(this.is_sample_order_invoices) {
        this.$refs.sampleOrderInvoice.openPopup(
          id,
          product_order_code,
          status,
          last_email_sent_at !== '',
          customer_id,
          customer_lead
        )
      } else {
        this.$refs.salesOrderInvoice.openPopup(
          id,
          product_order_code,
          status,
          last_email_sent_at !== '',
          customer_id,
        )
      }
    },
    async onClickUpdateSampleInvoice(invoice) {
      await this.$refs.updateSampleOrderInvoicePopUp.openPopup(
        invoice.id,
        invoice.sample_order_id,
        invoice.invoice_currency || 'GBP',
        invoice.fx_value || 1
      )
    },
    onClickViewProductOrder(id) {
      if(this.is_sample_order_invoices) {
        this.$router.push(`/pages/sample-orders/${id}`)
      } else {
        this.$router.push(`/pages/product-orders/${id}`)
      }
    },
    checkOverDue(due_date, status_name) {
      let now = moment()
      let ddd = moment(due_date, 'DD/MM/YYYY')
      let gap = now.diff(ddd, 'days')
      return gap > 0 && !['Paid'].includes(status_name);
    },
    async onClickConfirmStatusChange(id, status, invoice_number) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: `Confirm ~ Invoice Number ${invoice_number}`,
          text: 'Are you sure you want to change the status ?',
          accept: this.onClickUpdateInvoiceStatus,
          parameters: [id, status]
        })
    },
    async onClickUpdateInvoiceStatus(params) {
      await this.$vs.loading({
        container: '#invoice-list',
        scale: 0.45
      })
      try {
        if(this.is_sample_order_invoices) {
          await CustomerRepository.sampleInvoiceStatusChange(params[0], params[1])
        } else {
          await CustomerRepository.invoiceStatusChange(params[0], params[1])
        }
        await this.fetchInvoiceList()
        this.showSuccessMessage('Invoice status changed successfully!')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#invoice-list > .con-vs-loading')
    },
    async onClickSageSyncInvoice(row_data, indextr) {
      await this.$vs.loading({
        container: `#invoice_row_${indextr}`,
        scale: 0.45
      })
      try {
        const inputDate = row_data.date;
        const parsedDate = moment(inputDate, "DD/MM/YYYY");
        const formattedDate = parsedDate.format("YYYY-MM-DDTHH:mm:ss");

        const document_goods_value = this.calculateTotalInvoiceAmount(row_data.items, row_data.add_cost)
        let nominal_analysis_items = row_data.items.filter((x) => x.sage_nominal_code && x.sage_nominal_code.code)
        let nominal_analysis_items_add_cost = row_data.add_cost.filter((x) => x.sage_nominal_code && x.sage_nominal_code.code)
        nominal_analysis_items = nominal_analysis_items.concat(nominal_analysis_items_add_cost)

        // Fetch region 
        const cost_centre =  await this.fetchCustomerRegion(row_data.invoice_to_country)
        let total_tax_amount = 0 

        const payload = {
          invoice_id: row_data.id, 
          customer_id: row_data.sage_customer_id,
          invoice_type: 'sales',
          transaction_date: moment(row_data.date, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          due_date: moment(row_data.due_date, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          // exchange_rate: row_data.fx_value,
          reference: row_data.number,
          second_reference: row_data.product_order_code,
          document_goods_value: document_goods_value,
          nominal_analysis_items: nominal_analysis_items.map((x) => {
            let tax_amount = Number(x.amount_in_vat) - Number(x.amount_ex_vat)
            total_tax_amount = total_tax_amount + tax_amount
            return {
              code: x.sage_nominal_code.code,
              narrative: x.formulation_code ? `${x.formulation_code || ''} ${x.formulation_name || ''}` : `${x.name || ''}`,
              value: x.amount_ex_vat,
              department: x.sage_department ? x.sage_department.name : '',
              cost_centre: cost_centre || ''
            }
          })
        }
        if(Number(total_tax_amount) > 0) {
          // injecting 2200 sales tax row
          payload.nominal_analysis_items.push({
            code: 2200,
            narrative: row_data.number,
            value: Number(total_tax_amount).toFixed(2),
            department: '',
            cost_centre: ''
          })
        }
        await SageRepository.createSalesOrderInvoice(payload)
        await this.refreshData()
      } catch (error) {
        this.$vs.loading.close(`#invoice_row_${indextr} > .con-vs-loading`)
        this.convertAndNotifySageError(error)
        this.sageAuthHandler(error.response.status)
      }
      this.$vs.loading.close(`#invoice_row_${indextr} > .con-vs-loading`)
    },

    async onClickSageSyncSampleInvoice(row_data, indextr){

      const inputDate = row_data.date;
      const parsedDate = moment(inputDate, "DD/MM/YYYY");
      const formattedDate = parsedDate.format("YYYY-MM-DDTHH:mm:ss");

      const fx_rate = row_data.fx_value || 1
      const document_goods_value = this.calculateTotalInvoiceAmount(row_data.items, row_data.add_cost, fx_rate)
      let nominal_analysis_items = row_data.items.filter((x) => x.sage_nominal_code && x.sage_nominal_code.code)
      let nominal_analysis_items_add_cost = row_data.add_cost.filter((x) => x.sage_nominal_code && x.sage_nominal_code.code)
      nominal_analysis_items = nominal_analysis_items.concat(nominal_analysis_items_add_cost)
      const cost_centre =  await this.fetchCustomerRegion(row_data.invoice_to_country)
      let total_tax_amount = 0

      const payload = {
          invoice_id: row_data.id, 
          customer_id: row_data.sage_customer_id,
          invoice_type: 'sample',
          transaction_date: moment(row_data.date, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          // due_date: moment(row_data.due_date, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          // exchange_rate: row_data.fx_value,
          reference: row_data.number,
          second_reference: row_data.product_order_code,
          document_goods_value: document_goods_value,
          nominal_analysis_items: nominal_analysis_items.map((x) => {
            const amountExVat = x.formulation_code
              ? this.calculateItemAmountExVat(x, fx_rate)
              : this.calculateCostAmountExVat(x, fx_rate)
            const amountInVat = x.formulation_code
              ? this.calculateItemAmountInVat(x, fx_rate)
              : this.calculateCostAmountInVat(x, fx_rate)
            let tax_amount = Number(amountInVat) - Number(amountExVat)
            total_tax_amount = total_tax_amount + tax_amount
            return {
              code: x.sage_nominal_code.code,
              narrative: x.formulation_code ? `${x.formulation_code || ''} ${x.formulation_name || ''}` : `${x.name || ''}`,
              value: amountExVat,
              department: x.sage_department ? x.sage_department.name : '',
              cost_centre: cost_centre || ''
            }
          })
        }

        if(Number(total_tax_amount) > 0) {
          // injecting 2200 sales tax row
          payload.nominal_analysis_items.push({
            code: 2200,
            narrative: row_data.number,
            value: Number(total_tax_amount).toFixed(2),
            department: '',
            cost_centre: ''
          })
        }

        await SageRepository.createSalesOrderInvoice(payload)
        await this.refreshData()


    },
    onClickCustomer(customer_id) {
      this.$router.push({path: `/pages/manage-nimble/customers/${customer_id}`})
    },
    async onChangeInvoiceType() {
      await this.fetchInvoiceList()
    },
    async fetchCustomerRegion(country) {
      const { data } = (await RegionsRepository.getListOfRegions(1, `filter[country]=${country}`, 150, '')).data
      return data.length > 0 && data[0].name.length < 4 ? data[0].name : null
    },
    async onClickViewInvoiceLogs(id, code) {
      await this.$refs.viewSalesOrderInvoiceLogPopUp.openPopup(id, code)
    },
    onClickViewCustomerLead(lead) {
      let path = '';
      switch (lead.status) {
        case 'Lead':
          path = `/pages/crm/marketing-leads-suspect?search=${lead.code}`;
          break;
        case 'Subscriber':
          path = `/pages/crm/marketing-leads-influence?search=${lead.code}`;
          break;
        case 'Pending':
          path = `/pages/crm/marketing-leads?search=${lead.code}`;
          break;
      }
      if (path) {
        const route = this.$router.resolve({ path });
        window.open(route.href, '_blank');
      }
    }
  },
  watch: {
    page() {
      this.fetchInvoiceList()
    },
    perPage() {
      this.fetchInvoiceList()
    },
    invoice_total_date() {
      this.fetchSalesOrderInvoiceTotal()
    }
  }
}
</script>


<style scoped>
.user-edit-popup >>> .vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
